import { createEffect } from 'effector';

import { HospitalityService } from 'apps/request/services';

export const fetchOpenHospitalityStays = createEffect({
  handler: HospitalityService.getOpenHospitalityStays,
});
